import {
  MessageChannel,
  MessageTemplateType,
} from '@/features/dashboard/messageTemplates/types/MessageTemplateDto.ts';

export const messageTemplateTypeLabels: Record<MessageTemplateType, string> = {
  [MessageTemplateType.BOOKING_CONFIRMATION]: 'Potwierdzenie rezerwacji',
  [MessageTemplateType.TOUR_START_REMINDER]:
    'Przypomnienie o rozpoczęciu wyjazdu',
  [MessageTemplateType.TOUR_END_REMINDER]:
    'Przypomnienie o zakończeniu wyjazdu',
  [MessageTemplateType.TOUR_CANCELLATION]: 'Odwołanie wyjazdu',
  [MessageTemplateType.INVITATION]: 'Zaproszenie',
  [MessageTemplateType.BOOKING_CHANGE_PENDING]:
    'Zmiana rezerwacji do akceptacji',
  [MessageTemplateType.BOOKING_CHANGE_APPLIED]: 'Zmiana rezerwacji wprowadzona',
  [MessageTemplateType.BOOKING_WITHDRAWN]: 'Potwierdzenie rezygnacji',
  [MessageTemplateType.CONSENT_PENDING]: 'Prośba o podpis dokumentów',
  [MessageTemplateType.CUSTOM]: 'Własny szablon',
};

export const getMessageTemplateTypeLabel = (
  type: MessageTemplateType,
): string => {
  return messageTemplateTypeLabels[type] ?? type;
};

/**
 * Kiedy wiadomość wychodzi — zdanie pod nazwą szablonu na liście ustawień.
 * Klucz to kanał i typ, bo ten sam typ wysyła się inaczej e-mailem i SMS-em.
 * Serwer decyduje, jakie typy zwróci, więc brak wpisu jest dozwolony i po
 * prostu gasi podpis wiersza.
 */
export const messageTemplateSendTimings: Record<
  MessageChannel,
  Partial<Record<MessageTemplateType, string>>
> = {
  [MessageChannel.EMAIL]: {
    [MessageTemplateType.BOOKING_CONFIRMATION]:
      'Wysyłane od razu po złożeniu rezerwacji przez uczestnika.',
    [MessageTemplateType.TOUR_START_REMINDER]:
      'Wysyłane 3 dni przed datą rozpoczęcia wyjazdu.',
    [MessageTemplateType.TOUR_END_REMINDER]:
      'Wysyłane dzień przed datą zakończenia wyjazdu.',
    [MessageTemplateType.INVITATION]:
      'Wysyłane, gdy zapraszasz nową osobę do panelu firmy.',
    [MessageTemplateType.BOOKING_CHANGE_PENDING]:
      'Wysyłane, gdy uczestnik zgłosi zmianę wymagającą Twojej akceptacji.',
    [MessageTemplateType.BOOKING_CHANGE_APPLIED]:
      'Wysyłane po zaakceptowaniu zmiany w rezerwacji.',
    [MessageTemplateType.BOOKING_WITHDRAWN]:
      'Wysyłane po anulowaniu rezerwacji przez uczestnika lub biuro.',
    [MessageTemplateType.CONSENT_PENDING]:
      'Wysyłane, gdy poprosisz zapisującego o podpisanie brakujących dokumentów.',
  },
  [MessageChannel.SMS]: {
    [MessageTemplateType.BOOKING_CONFIRMATION]:
      'Wysyłane od razu po złożeniu rezerwacji, jeśli podano numer telefonu.',
    [MessageTemplateType.BOOKING_CHANGE_PENDING]:
      'Wysyłane, gdy uczestnik zgłosi zmianę wymagającą Twojej akceptacji.',
    [MessageTemplateType.BOOKING_CHANGE_APPLIED]:
      'Wysyłane po zaakceptowaniu zmiany w rezerwacji.',
    [MessageTemplateType.BOOKING_WITHDRAWN]:
      'Wysyłane po anulowaniu rezerwacji przez uczestnika lub biuro.',
  },
};

export const getMessageTemplateSendTiming = (
  channel: MessageChannel,
  type: MessageTemplateType,
): string | undefined => messageTemplateSendTimings[channel][type];
